<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/Sinput/SInputEditor'
export default {
  name: 'SDIdentityEditor',
  extends: compoment
}
</script>
